<template>
    <v-card tile class="bg-dialog-img-color" height="100%"
        style="display: flex; align-items: center; justify-content: center;">
        <v-overlay v-if="overlay">
            <v-progress-circular indeterminate color="#cceefc" size="72"></v-progress-circular>
        </v-overlay>
        <v-card-text v-else>
            <v-card-text v-if="check_bypass" :class="xs_mode ? 'pt-2' : 'pt-2 px-10'">
                <v-row justify="center" align="center" style="height: 100%" no-gutters>
                    <v-col cols="11" xs="11" sm="9" md="6" :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'py-1'">
                        <v-card class="elevation-1" rounded="xl">
                            <v-card-title class="black--text text_header font-weight-bold"
                                :class="xs_mode ? 'py-3 px-4' : ''">
                                <v-spacer></v-spacer>
                                <span class="py-5 font-30">เลือกสิทธิ์การใช้งาน</span>
                                <v-spacer></v-spacer>
                            </v-card-title>
                            <v-card-text rounded="xl">
                                <v-row align="center" justify="center">
                                    <v-col cols="12" sm="11" class="py-1"><span
                                            class="font-18 black--text w-500">เลือกสถานพยาบาล</span>
                                    </v-col>
                                    <v-col cols="12" sm="11" class="pb-4">
                                        <v-autocomplete rounded v-model="biz_id" :items="bizList" item-text="biz_name"
                                            item-value="biz_id" return-object solo dense outlined flat
                                            hide-details="auto" placeholder="เลือกสถานพยาบาล" style="font-size: 14px"
                                            color="#00a99d" @change="selectBiz()"
                                            item-color="teal darken-2"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="11" class="py-1" v-if="redirect_form != 'ehp-redirect'">
                                        <span class="font-18 black--text w-500">เลือกสิทธิ์</span>
                                    </v-col>
                                    <v-col cols="12" sm="11" class="py-1" v-if="redirect_form != 'ehp-redirect'">
                                        <v-autocomplete rounded v-model="changeRole" :items="checkbiz(roleList)"
                                            item-text="role" item-value="role" return-object solo dense outlined flat
                                            hide-details="auto" placeholder="เลือกสิทธิ์" style="font-size: 14px"
                                            color="#00a99d" item-color="teal darken-2"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="11" class="py-6">
                                        <v-row align="center" justify="center"><v-col cols="12" lg="6" md="6"
                                                sm="6"><v-btn rounded block color="#00a99d" outlined @click="backward()"
                                                    :disabled="redirect_form == 'ehp-redirect'"><span
                                                        class="font-16">ย้อนกลับ</span>
                                                </v-btn></v-col>
                                            <v-col cols="12" lg="6" md="6" sm="6"><v-btn rounded block depressed
                                                    :disabled="!changeRole" :loading="btn_loading"
                                                    :style="buttonStyle_confirm" @click="confirmSelectBiz()"><span
                                                        class="font-16">ตกลง</span></v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text v-else :class="xs_mode ? 'pt-2' : 'pt-2 px-10'">
                <v-row justify="center" align="center" style="height: 100%;" no-gutters>
                    <v-card class="elevation-1 pa-10" rounded="xl">
                        <v-icon class="d-flex justify-center align-center" size="100"
                            color="#facea8">mdi-alert-circle</v-icon>
                        <div class="font-28 w-bold py-5 d-flex justify-center align-center" style="color: red;">
                            คุณไม่มีสิทธิ์เข้าใช้งาน</div>
                        <div class="font-18">เนื่องจากหน่วยบริการของคุณยังไม่เปิดใช้บริการในส่วนนี้</div>
                    </v-card>
                </v-row>
            </v-card-text>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
    data() {
        return {
            redirect_form: this.$route.params.key || "",
            shared_token: this.$route.query.code || "",
            hos_code: this.$route.query.state || "",
            check_bypass: false,
            changeRole: null,
            biz_id: null,
            role: null,
            addSessionStorage: [],
            oneId: null,
            overlay: false,
            btn_loading: false
        }
    },
    mounted() {
        this.loginRedirect()
        // console.log("redirect_form", this.redirect_form)
        // console.log("shared_token", this.shared_token)
        // if (this.redirect_form == 'ehp-redirect') {
        //     console.log('ehp')
        // } else {
        //     console.log('orther')
        // }
    },
    computed: {
        ...mapState(["login_account"]),
        xs_mode() {
            return this.$vuetify.breakpoint.xsOnly;
        },
        buttonStyle() {
            return {
                background: this.checkbox_consent
                    ? 'linear-gradient(to right, #8dd2cd 0%, #00a99d 100%)'
                    : '#eff6fc',
                color: '#ffffff',
            };
        },
        buttonStyle_confirm() {
            return {
                background: this.changeRole
                    ? '#00a99d' : '#a6a6a6',
                color: '#ffffff',
            };
        },
    },
    methods: {
        ...mapMutations([
            "setProfile",
            "setBiz",
            "setRole",
            "setStatusReady",
            "setClinic",
            "setLogin",
            "clearStateLogin",
            "setRedirect",
        ]),
        async loginRedirect() {
            this.overlay = true;
            await this.axios
                .post(`${process.env.VUE_APP_BACKEND_URL}/v1/provider/loginProvider`, {
                    redirect_uri: `${window.location.origin}/by-pass/${this.redirect_form}`,
                    shared_token: this.shared_token,
                    type: this.redirect_form == 'ehp-redirect' ? 'ehp_redirect' : 'provider',
                    hos_code: this.hos_code || null
                })
                .then((res) => {
                    const {
                        data: {
                            data: { account_detail: { one_id = "" } = {} } = {},
                            code,
                        } = {},
                    } = res;
                    if (code == 200) {
                        this.check_bypass = true
                        this.setProfile(res.data.data);
                        this.setRedirect('loginWithRedirect');
                        // this.setLogin(loginData);
                        this.addSessionStorage = res.data.data;
                        this.setClinic(this.addSessionStorage.accountDetail.clinics);
                        sessionStorage.type_login = "provider"
                        this.bizList = Object.assign(
                            [],
                            res.data.data.accountDetail.clinics
                        );
                        this.roleList = Object.assign(
                            [],
                            res.data.data.accountDetail.clinics
                        );
                        this.oneId = one_id;
                        if (this.hos_code) {
                            this.biz_id = res.data.data.accountDetail.clinics[0]
                            this.changeRole = res.data.data.accountDetail.clinics[0].role[0]
                            this.confirmSelectBiz()
                        }
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                    const { response: { data: { message } = {} } = {} } = error;
                    let text = "เข้าสู่ระบบไม่สำเร็จ";
                    message === "do not have permission"
                        ? (text = "ไม่มีสิทธิ์เข้าใช้งาน")
                        : text;
                    message === "The user credentials were incorrect."
                        ? (text = "user หรือ pasword ไม่ถูกต้อง")
                        : text;
                    this.biz_ibi;

                    this.$swal.fire({
                        icon: "warning",
                        title: text,
                        showConfirmButton: false,
                        timer: 1000,
                    });
                });
        },
        selectBiz() {
            if (this.redirect_form == 'ehp-redirect') {
                this.changeRole = this.biz_id.role[0]
            }
        },
        backward() {
            if (
                this.login_account &&
                this.login_account.username !== "" &&
                this.login_account.password !== ""
            ) {
                this.clearStateLogin();
                this.setRedirect('');
                this.$router.push("/");
            } else {
                // this.editedIndex = -1;
                this.$router.push("/");
            }
        },
        checkbiz(data) {
            console.log("🚀 ~ checkbiz ~ data:", data)
            let return_data = [];
            if (this.biz_id) {
                data.forEach((element) => {
                    if (element.biz_id === this.biz_id.biz_id) {
                        this.biz_id.role.forEach((role) => {
                            if (element.role.includes(role)) {
                                return_data.push(role);
                            }
                        });
                    }
                });
            }
            return return_data;
        },
        async confirmSelectBiz() {
            await this.setBiz(this.biz_id);
            await this.setRole(this.changeRole);
            this.btn_loading = true;
            setTimeout(() => {
                this.overlay = false;
                this.$router.push({ name: "Dashboard" });
                if (this.changeRole == "เจ้าหน้าที่ HR") {
                    this.$router.push({ name: "health-check" });
                } else if (this.changeRole == "ehp_redirect") {
                    this.$router.push({ name: "HomeVisit" });
                }
                // if (this.changeRole == "แพทย์") {
                //   this.$router.push({ name: "Dashboard" });
                // } else if (this.changeRole == "พยาบาล") {
                //   this.$router.push({ name: "DashboardNurse" });
                // } else if (this.changeRole == "เภสัชกร") {
                //   this.$router.push({ name: "DashboardNurse" });
                // } else if (this.changeRole == "admin") {
                //   this.$router.push({ name: "DashboardNurse" });
                // }
            }, 500);
            setTimeout(() => {
                this.btn_loading = false;
            }, 1000);
            sessionStorage.role_name = this.changeRole;
            sessionStorage.access_token = this.addSessionStorage.access_token;
            sessionStorage.account_id = this.addSessionStorage.account_id;
            sessionStorage.oneId = this.addSessionStorage.accountDetail.one_id;
            sessionStorage.biz_id = this.biz_id.biz_id;
            sessionStorage.biz_name = this.biz_id.biz_name;
            sessionStorage.accountName =
                this.addSessionStorage.accountDetail.account_title_th +
                this.addSessionStorage.accountDetail.first_name_th +
                " " +
                this.addSessionStorage.accountDetail.last_name_th;
            const data = {
                one_id: sessionStorage.oneId,
                biz_id: sessionStorage.biz_id,
                role: sessionStorage.role_name,
                status: true,
            };
            this.axios
                .put(`${process.env.VUE_APP_BACKEND_URL}/v1/staffs/status`, data)
                .then((res) => {
                    if (res.data) {
                        this.setStatusReady(true);
                    }
                });
            // this.setStatusReady(true);
        },
    }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Sarabun&display=swap");

.bg-dialog-img-color {
    height: 100%;
    background-image: url("../assets/img/bg.png");
    background-size: 370%;
}
</style>